<template>
  <div class="pagination-container" v-if="pageNum > 1">
    <div class="pagination__main-body">
      <div class="main__direction-bt">
        <div
          class="bt--item --prev"
          @click="prev"
          :class="{
            'no-cursor': Number(this.page) === 1
          }"
        >
          &lt;&lt;
        </div>
        <div
          class="bt--item"
          @click="toTop"
          :class="{
            'no-cursor': Number(this.page) === 1
          }"
        >
          First
        </div>
      </div>
      <div class="main_pagination-size">
        <div
          class="site--item"
          v-for="(item, index) in pages"
          :class="{
            acitve: Number(item) === Number(page)
          }"
          :key="index"
          @click="gochange(item)"
        >
          {{ item }}
        </div>
        <div class="site--item no-cursor" v-if="!$isMobile && pageNum > showLimit">...</div>
      </div>
      <div class="main__direction-bt">
        <div
          class="bt--item"
          @click="toBottom"
          :class="{
            'no-cursor': Number(this.page) === Number(this.pageNum)
          }"
        >
          Last
        </div>
        <div
          :class="{
            'no-cursor': Number(this.page) === Number(this.pageNum)
          }"
          class="bt--item --next"
          @click="next"
        >
          &gt;&gt;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    config: {
      type: Object,
      default: null,
    },
    demand_mold_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pageNum: this.config.page_num,
      showLimit: this.$isMobile ? 5 : 9,
    };
  },
  computed: {
    page() {
      return this.$route.query.page || 1;
    },
    pages() {
      let beginPage = Math.max(0, this.page - Math.ceil(this.showLimit / 2));
      let endPage = beginPage + this.showLimit - 1;
      if (endPage >= this.pageNum) {
        endPage = this.pageNum - 1;
        beginPage = Math.max(0, endPage - this.showLimit + 1);
      }
      const temp = [];
      for (let i = beginPage; i <= endPage; ++i) {
        temp.push(i + 1);
      }
      return temp;
    },
  },
  created() {},
  methods: {
    prev() {
      if (this.page > 1) {
        this.changePage(this.page - 1);
      }
    },
    next() {
      if (this.page < this.pageNum) {
        this.changePage(this.page + 1);
      }
    },
    toTop() {
      this.changePage(1);
    },
    toBottom() {
      this.changePage(this.pageNum);
    },
    gochange(num) {
      this.changePage(num);
    },
    changePage(page) {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query = Object.assign(query, {
        page,
        // demand_mold_id: this.demand_mold_id
      });
      this.$router.push({
        path: '',
        query,
      });
    },
  },
};
</script>

<style></style>
